// TEMP hack: the salary of these projects must not be shown anywhere in the portal.
// Remove once there is a proper setting for it.
const HIDDEN_SALARY_PROJECT_IDS = [611459, 611470];

export function isSalaryHidden(projectId: number | string) {
  return HIDDEN_SALARY_PROJECT_IDS.includes(Number(projectId));
}
